import AppHeader from '../AppHeader'

export default {
  name: 'master-tanomail-edit',
  async created () {
    await this.getShop()
    await this.getTanomail()
  },
  data () {
    return {
      canValidate: true,
      represent_code: '2001500099',
      management_number: 'KANRIBU',
      receive_responsible: '荷受取担当者',
      shops: [],
      tanomail: [],
      isSaving: false,
      shopGetCallbackFlag: false,
      searchCallbackFlag: false
    }
  },
  computed: {
    validation () {
      let validation = {
        shop_id: !!this.tanomail.shop_id,
        group_code: !!this.tanomail.group_code,
        login_id: !!this.tanomail.login_id,
        password: !!this.tanomail.password
      }
      if (!this.canValidate) {
        Object.keys(validation).forEach(
          key => {
            validation[key] = true
          }
        )
      }
      return validation
    },
    validationAll () {
      if (!this.validation.shop_id) return false
      if (!this.validation.group_code) return false
      if (!this.validation.login_id) return false
      if (!this.validation.password) return false

      return true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getShop () {
      this.shopGetCallbackFlag = false
      let data = {}
      let res = await this.$store.dispatch('GET_SHOP_TARGET_STOCK', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.shops = res.data
      this.shopGetCallbackFlag = true
    },
    async getTanomail () {
      let res = await this.$store.dispatch('GET_TANOMAIL', {id: this.$route.params.id})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.tanomail = res.tanomail
      this.searchCallbackFlag = true
    },
    async onClickSave () {
      // 連打対応
      if (this.isSaving) return false
      this.isSaving = true

      // 保存処理
      await this.$store.dispatch('UPDATE_MASTER_TANOMAIL', {
        data: {
          id: this.$route.params.id,
          shop_id: this.tanomail.shop_id,
          represent_code: this.represent_code,
          group_code: this.tanomail.group_code,
          login_id: this.tanomail.login_id,
          password: this.tanomail.password,
          management_number: this.management_number,
          receive_responsible: this.receive_responsible
        }
      })
      .catch(err => {
        console.error(err)
        return
      })

      // たのめーるアカウント一覧へ戻る
      this.$router.push('/master_tanomail_list')
    },
    onClickCancel () {
      this.$router.push('/master_tanomail_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-tanomail-edit.js